import { Link } from 'react-router-dom'
import cn from 'classnames'
import { MdAccountTree, MdAssignmentTurnedIn, MdFileDownload, MdShowChart } from 'react-icons/md'

const ConveyanceTableHeader = ({
    chain,
    handleChain,
    chainHeaders,
    getTooltipContent,
    documentsToProcess,
    setShowFlowchart,
    getTractLink,
    getTotalConveyances,
    exportChain,
    exportLoading,
    
    // handleDeleteTitleChain,
}) => {
    
    return (
        
        <thead>
            
            <tr className="sticky top-0">
                <td className="!p-0 border-none" colSpan={chainHeaders.length + 1}>
                    <div className="flex justify-between bg-base-200 sticky top-0 pt-2 ">
                        
                        <div className="flex flex-col gap-2 mx-4">
                            
                            <div
                                data-tooltip-id="default-tip"
                                data-tooltip-content={getTooltipContent()}>
                                <button
                                    className={cn('btn', {
                                        'btn-neutral': chain?.status === 'stale',
                                        'btn-primary': chain?.status !== 'stale',
                                    })}
                                    onClick={handleChain}
                                    disabled={
                                        chain?.status === 'processing'
                                        || documentsToProcess.length > 0
                                    }>
                                    <MdAccountTree />Auto-Chain
                                </button>
                            </div>
                            
                            <button
                                className="btn btn-primary"
                                disabled={exportLoading}
                                onClick={exportChain}>
                                <MdFileDownload />Export
                            </button>
                            
                            <button
                                className="btn btn-primary"
                                onClick={() => setShowFlowchart(true)}>
                                <MdShowChart />Flowchart
                            </button>
                            
                            {/* <button
                                className="btn btn-warning"
                                onClick={() => handleDeleteTitleChain(true)}>
                                <MdDelete />Delete Title Chain
                            </button> */}
                            
                            {chain.tractId &&
                                <Link
                                    className="btn btn-secondary"
                                    to={getTractLink(chain)}>
                                    <MdAssignmentTurnedIn />Ownership
                                </Link>
                            }
                        
                        </div>
                        
                        <div className="flex flex-col items-end gap-2 pr-2 pb-2 bg-base-200 text-sm">
                            <span>Document Name</span>
                            <span>Instrument Type</span>
                            <span>Book Type / Volume / Page</span>
                            <span>Instrument #</span>
                            <span>File Date</span>
                            <span>Effective / Instrument Date</span>
                            <span>Grantors</span>
                            <span>Grantees</span>
                            <span>Comments</span>
                        </div>
                    
                    </div>
                </td>
            </tr>
            
            <tr className="bg-base-200 sticky top-[260px]">
                <td className="!p-0">
                    <div className="border-b border-parse-800 pb-2 px-2">Sum Check</div>
                </td>
                <td colSpan={chainHeaders.length} className="!p-0">
                    <div className="flex border-b border-parse-800 pb-2 px-2 gap-4">
                        {chainHeaders.map(type => {
                            const total = getTotalConveyances(type)
                            const textColor = parseFloat(total) !== 1.0
                                ? 'text-error' : 'text-slate-500'
                            
                            return (
                                <div
                                    key={`sumCheckTotal-${type}`}
                                    className={`flex-1 text-center ${textColor}`}>
                                    {total}
                                </div>
                            )
                        })}
                    </div>
                </td>
            </tr>
            
            <tr className="bg-base-100 sticky top-[288px] ">
                <th>Parties</th>
                {chainHeaders.map(type => <th key={`sum-header-${type}`}>{type}</th>)}
            </tr>
        
        </thead>
        
    )
    
}

export default ConveyanceTableHeader
